import {IconButton} from "@mui/material";
import React from 'react'
import "./TitleComponent.css";

export default function TitleComponent(props) {
    return (
        <>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                {props.icon && (
                    <IconButton
                        className={'icon'}
                        disableRipple={true}
                        style={{color: 'var(--greytext)', padding: 5}}
                    >
                        {props.icon}
                    </IconButton>
                )}
                <div className={'title'}>
                    {props.title}
                </div>
            </div>
            <hr align="left" style={{marginBottom: 20}} className={'hr'}/>
        </>
    )
}
